import React from 'react'

import {chakra} from '@chakra-ui/react'

/**
 * The netsnek lockup: snake mark, wordmark and the "Software & Security"
 * tagline. Mark, wordmark and tagline paint in `currentColor`, so callers set
 * the colour with the `color` prop (`color="black"` in the light nav,
 * `color="white"` on dark); only the arrow keeps the brand orange.
 *
 * The viewBox hugs the artwork with the same relative breathing room the
 * previous logo had (~11% of the height above it), so the lockup keeps its
 * perceived size and stays flush left where the old one did. Its own
 * proportions are taller and narrower than the previous drawing (3.0:1 rather
 * than 4:1), which is why the viewBox is not simply the delivered 512x128.
 */
export const Logo = (props: any) => {
  return (
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      width="full"
      height="full"
      viewBox="11.7 -17.1 477.5 157"
      preserveAspectRatio="xMidYMid meet"
      shapeRendering="geometricPrecision"
      color="#1F2328"
      {...props}>
      <g>
      <g id="mark">
      <path id="squarel" fill="none" d="M 134.42,13.56
      C 122.38,1.55 105.06,0.21 83.89,0.21
      62.73,0.21 45.37,1.57 33.33,13.60
      21.28,25.63 20.06,42.95 20.06,64.12
      20.06,85.28 21.28,102.61 33.33,114.64
      45.37,126.68 62.70,127.89 83.89,127.89
      105.09,127.89 122.42,126.68 134.46,114.64
      146.51,102.61 147.73,85.30 147.73,64.12
      147.72,42.92 146.50,25.58 134.42,13.56
      134.42,13.56 134.42,13.56 134.42,13.56
      134.42,13.56 134.42,13.56 134.42,13.56 Z" />
      <path id="snek" fill="currentColor" d="M 38.70,84.67
      C 23.24,46.86 57.46,7.51 97.25,17.96
      121.06,24.11 136.93,48.50 132.40,72.47
      128.69,95.43 106.22,112.84 83.02,110.39
      72.00,109.46 61.48,104.34 54.16,96.25
      53.85,95.94 53.96,95.53 54.16,95.22
      54.47,95.02 54.89,95.02 55.09,95.22
      62.82,102.19 73.03,106.08 83.13,106.18
      109.10,106.59 129.10,81.80 122.50,57.00
      119.10,43.48 107.87,32.41 94.16,29.44
      81.07,26.47 66.43,31.39 57.77,41.84
      49.11,51.98 46.74,66.94 52.10,79.13
      55.40,88.05 42.72,93.27 38.70,84.67 Z" />
      <path id="arrow15" fill="#f77f00" stroke="none" stroke-width="0" d="M 88.99 45 L 86 45 L 89 55 L 59 55 L 62 65 L 108.99 65 Z
      M 110 69 L 63.01 69 L 83.01 89 L 86 89 L 83 79 L 113 79 Z" />
      </g>
      <g id="wordmark" fill="currentColor">
      <path id="netsnek-n" d="M 168.02,85.54
      C 168.02,85.54 168.02,85.54 168.02,85.54
      168.02,83.89 169.15,82.44 170.80,82.13
      170.80,82.13 171.72,81.92 171.72,81.92
      173.37,81.62 174.50,80.27 174.50,78.62
      174.50,78.62 174.50,39.38 174.50,39.38
      174.50,37.72 173.37,36.38 171.72,36.07
      171.72,36.07 170.80,35.87 170.80,35.87
      169.15,35.56 168.02,34.21 168.02,32.56
      168.02,32.56 168.02,32.46 168.02,32.46
      168.02,30.59 169.56,29.05 171.42,29.05
      171.42,29.05 182.95,29.05 182.95,29.05
      184.08,29.05 185.21,29.67 185.83,30.59
      185.83,30.59 211.87,72.11 211.87,72.11
      211.87,72.11 212.08,72.01 212.08,72.01
      212.08,72.01 212.08,39.48 212.08,39.48
      212.08,37.83 210.84,36.38 209.20,36.17
      209.20,36.17 207.34,35.87 207.34,35.87
      205.70,35.56 204.46,34.21 204.46,32.56
      204.46,32.56 204.46,32.56 204.46,32.56
      204.46,30.70 206.01,29.15 207.86,29.15
      207.86,29.15 224.23,29.15 224.23,29.15
      226.08,29.15 227.63,30.70 227.63,32.56
      227.63,32.56 227.63,32.66 227.63,32.66
      227.63,34.31 226.49,35.66 224.85,35.97
      224.85,35.97 223.92,36.17 223.92,36.17
      222.27,36.48 221.14,37.83 221.14,39.48
      221.14,39.48 221.14,85.54 221.14,85.54
      221.14,87.40 219.60,88.95 217.74,88.95
      217.74,88.95 213.21,88.95 213.21,88.95
      212.08,88.95 211.05,88.33 210.33,87.40
      210.33,87.40 183.56,45.26 183.56,45.26
      183.56,45.26 183.36,45.26 183.36,45.26
      183.36,45.26 183.36,78.62 183.36,78.62
      183.36,80.27 184.59,81.72 186.24,81.92
      186.24,81.92 188.09,82.23 188.09,82.23
      189.74,82.54 190.98,83.89 190.98,85.54
      190.98,85.54 190.98,85.54 190.98,85.54
      190.98,87.40 189.43,88.95 187.58,88.95
      187.58,88.95 171.21,88.95 171.21,88.95
      169.46,88.84 168.02,87.40 168.02,85.54
      168.02,85.54 168.02,85.54 168.02,85.54 Z" />
      <path id="netsnek-e" d="M 249.34,88.87
      C 245.23,88.87 241.63,87.94 238.55,86.08
      235.47,84.24 233.11,81.66 231.46,78.46
      229.82,75.17 228.89,71.46 228.89,67.33
      228.89,67.33 228.89,65.58 228.89,65.58
      228.89,61.36 229.72,57.54 231.36,54.24
      233.00,50.94 235.37,48.27 238.24,46.41
      241.12,44.56 244.51,43.53 248.21,43.53
      252.21,43.53 255.50,44.35 258.17,45.90
      260.84,47.44 262.89,49.71 264.23,52.70
      265.57,55.59 266.28,59.09 266.28,63.21
      266.28,63.21 266.28,63.21 266.28,63.21
      266.28,66.40 263.72,68.98 260.43,68.98
      260.43,68.98 239.37,68.98 239.37,68.98
      239.37,68.98 239.27,69.19 239.27,69.19
      239.37,71.46 239.88,73.51 240.71,75.27
      241.53,77.01 242.76,78.46 244.40,79.49
      245.95,80.52 247.90,81.04 250.16,81.04
      252.42,81.04 254.68,80.73 256.63,80.11
      257.55,79.80 258.38,79.39 259.30,79.08
      260.84,78.26 262.79,78.87 263.61,80.52
      263.61,80.52 263.61,80.52 263.61,80.52
      264.64,82.58 263.82,85.06 261.87,86.08
      260.94,86.60 259.81,87.01 258.68,87.53
      256.01,88.46 252.83,88.87 249.34,88.87 Z
      M 239.58,61.87
      C 239.58,61.87 255.50,61.87 255.50,61.87
      256.12,61.87 256.53,61.36 256.53,60.84
      256.53,60.84 256.53,60.84 256.53,60.84
      256.53,58.99 256.22,57.23 255.60,55.79
      254.99,54.35 254.16,53.21 252.93,52.39
      251.70,51.57 250.16,51.16 248.21,51.16
      246.56,51.16 245.12,51.57 243.89,52.49
      242.66,53.42 241.63,54.66 240.91,56.20
      240.19,57.75 239.68,59.60 239.37,61.56
      239.37,61.56 239.58,61.87 239.58,61.87 Z" />
      <path id="netsnek-t" d="M 294.09,86.87
      C 294.09,87.71 293.57,88.33 292.74,88.43
      292.33,88.54 291.91,88.64 291.39,88.64
      289.84,88.85 288.39,88.95 286.94,88.95
      283.20,88.95 280.20,87.91 278.12,85.83
      276.05,83.75 275.02,80.32 275.02,75.75
      275.02,75.75 275.02,48.61 275.02,48.61
      275.02,47.67 274.29,46.94 273.36,46.94
      273.36,46.94 272.22,46.94 272.22,46.94
      270.14,46.94 268.49,45.28 268.49,43.30
      268.49,43.30 268.49,43.30 268.49,43.30
      268.49,41.23 270.14,39.66 272.22,39.66
      272.22,39.66 273.36,39.66 273.36,39.66
      274.29,39.66 275.02,38.94 275.02,38.01
      275.02,38.01 275.02,32.59 275.02,32.59
      275.02,30.61 276.67,28.96 278.75,28.96
      278.75,28.96 281.65,28.96 281.65,28.96
      283.72,28.96 285.38,30.61 285.38,32.59
      285.38,32.59 285.38,38.01 285.38,38.01
      285.38,38.94 286.11,39.66 287.04,39.66
      287.04,39.66 290.46,39.66 290.46,39.66
      292.53,39.66 294.19,41.33 294.19,43.30
      294.19,43.30 294.19,43.30 294.19,43.30
      294.19,45.39 292.53,46.94 290.46,46.94
      290.46,46.94 287.04,46.94 287.04,46.94
      286.11,46.94 285.38,47.67 285.38,48.61
      285.38,48.61 285.38,75.75 285.38,75.75
      285.38,77.62 285.80,78.97 286.52,79.80
      287.25,80.63 288.39,81.05 289.73,81.05
      290.46,81.05 291.39,80.95 292.33,80.83
      292.33,80.83 292.33,80.83 292.33,80.83
      293.26,80.73 294.19,81.47 294.19,82.40
      294.19,82.40 294.09,86.87 294.09,86.87 Z" />
      <path id="netsnek-s" d="M 315.53,88.97
      C 312.44,88.97 309.45,88.66 306.77,88.04
      305.43,87.73 304.09,87.42 302.85,86.89
      300.27,86.07 298.62,83.69 298.62,81.11
      298.62,81.11 298.62,77.80 298.62,77.80
      298.62,75.62 300.37,73.76 302.64,73.76
      302.64,73.76 302.85,73.76 302.85,73.76
      304.71,73.76 306.25,75.01 306.77,76.76
      306.77,76.76 307.08,78.01 307.08,78.01
      307.39,79.35 308.42,80.38 309.76,80.90
      310.27,81.01 310.69,81.21 311.20,81.32
      312.44,81.62 313.78,81.73 315.33,81.73
      318.21,81.73 320.27,81.21 321.51,80.17
      322.75,79.14 323.37,77.90 323.37,76.35
      323.37,74.80 322.75,73.65 321.51,72.62
      320.27,71.59 317.80,70.65 314.29,69.93
      309.04,68.80 305.12,67.14 302.64,64.97
      300.17,62.80 298.93,60.00 298.93,56.49
      298.93,54.11 299.55,51.94 300.89,49.97
      302.13,48.01 304.09,46.46 306.56,45.32
      309.04,44.18 312.13,43.56 315.84,43.56
      319.14,43.56 322.13,43.87 324.71,44.60
      325.64,44.81 326.56,45.12 327.39,45.42
      329.76,46.35 331.41,48.53 331.41,51.12
      331.41,51.12 331.51,54.43 331.51,54.43
      331.51,56.69 329.76,58.46 327.49,58.46
      327.49,58.46 327.49,58.46 327.49,58.46
      325.64,58.46 323.99,57.11 323.57,55.35
      323.57,55.35 323.37,54.43 323.37,54.43
      323.06,53.18 322.23,52.04 321.00,51.63
      320.69,51.53 320.38,51.43 320.07,51.32
      318.93,51.01 317.70,50.80 316.25,50.80
      313.98,50.80 312.23,51.32 310.89,52.25
      309.55,53.28 308.93,54.53 308.93,55.97
      308.93,56.80 309.14,57.63 309.55,58.35
      309.96,59.08 310.79,59.69 312.03,60.31
      313.26,60.94 315.02,61.46 317.28,61.97
      322.96,63.31 327.08,65.08 329.55,67.14
      332.03,69.21 333.27,72.11 333.27,75.62
      333.27,79.55 331.82,82.76 328.94,85.24
      325.84,87.73 321.51,88.97 315.53,88.97 Z" />
      <path id="netsnek-n-2" d="M 336.38,85.44
      C 336.38,85.44 336.38,85.44 336.38,85.44
      336.38,83.78 337.51,82.45 339.15,82.14
      339.15,82.14 340.90,81.83 340.90,81.83
      341.83,81.62 342.44,79.97 342.44,79.15
      342.44,79.15 342.44,53.36 342.44,53.36
      342.44,52.44 341.83,51.61 340.90,51.51
      340.90,51.51 338.84,51.10 338.84,51.10
      337.20,50.78 336.07,49.34 336.07,47.69
      336.07,47.69 336.07,47.69 336.07,47.69
      336.07,45.84 337.61,44.28 339.46,44.28
      339.46,44.28 350.05,44.28 350.05,44.28
      351.08,44.28 351.90,45.01 352.00,46.04
      352.00,46.04 352.00,46.04 352.00,46.04
      352.11,47.58 354.06,48.31 355.19,47.27
      356.01,46.55 356.84,45.94 357.76,45.32
      359.92,44.08 362.39,43.46 365.16,43.46
      369.69,43.46 373.18,44.81 375.65,47.58
      378.22,50.37 379.45,54.71 379.45,60.58
      379.45,60.58 379.45,79.04 379.45,79.04
      379.45,79.97 380.07,81.62 381.00,81.73
      381.00,81.73 382.74,82.03 382.74,82.03
      384.39,82.34 385.52,83.78 385.52,85.33
      385.52,85.33 385.52,85.33 385.52,85.33
      385.52,87.20 383.98,88.74 382.13,88.74
      382.13,88.74 367.01,88.74 367.01,88.74
      365.16,88.74 363.62,87.20 363.62,85.33
      363.62,85.33 363.62,85.33 363.62,85.33
      363.62,83.68 364.75,82.34 366.29,82.03
      366.29,82.03 367.84,81.73 367.84,81.73
      368.76,81.52 369.38,79.86 369.38,79.04
      369.38,79.04 369.38,60.68 369.38,60.68
      369.38,57.38 368.76,55.02 367.42,53.67
      366.09,52.33 364.13,51.61 361.46,51.61
      359.51,51.61 357.76,52.02 356.32,52.95
      354.98,53.77 353.96,54.81 353.03,56.04
      352.83,56.35 352.72,56.76 352.72,57.07
      352.72,57.07 352.72,79.04 352.72,79.04
      352.72,79.97 353.34,81.52 354.27,81.73
      354.27,81.73 355.60,82.03 355.60,82.03
      357.14,82.34 358.27,83.78 358.27,85.33
      358.27,85.33 358.27,85.44 358.27,85.44
      358.27,87.30 356.73,88.84 354.88,88.84
      354.88,88.84 339.87,88.84 339.87,88.84
      337.82,88.84 336.27,87.30 336.38,85.44 Z" />
      <path id="netsnek-e2" d="M 407.42,88.80
      C 403.31,88.80 399.71,87.88 396.63,86.02
      393.55,84.17 391.19,81.59 389.54,78.40
      387.90,75.10 386.98,71.39 386.98,67.26
      386.98,67.26 386.98,65.51 386.98,65.51
      386.98,61.29 387.80,57.47 389.44,54.17
      391.09,50.88 393.45,48.21 396.32,46.35
      399.20,44.50 402.59,43.46 406.29,43.46
      410.30,43.46 413.58,44.28 416.25,45.83
      418.92,47.37 420.98,49.64 422.31,52.63
      423.65,55.52 424.37,59.02 424.37,63.14
      424.37,63.14 424.37,63.14 424.37,63.14
      424.37,66.34 421.80,68.91 418.51,68.91
      418.51,68.91 397.45,68.91 397.45,68.91
      397.45,68.91 397.35,69.12 397.35,69.12
      397.45,71.39 397.97,73.44 398.79,75.20
      399.61,76.95 400.84,78.40 402.49,79.42
      404.03,80.45 405.98,80.97 408.24,80.97
      410.50,80.97 412.76,80.67 414.71,80.04
      415.64,79.73 416.46,79.32 417.38,79.01
      418.92,78.19 420.88,78.81 421.70,80.45
      421.70,80.45 421.70,80.45 421.70,80.45
      422.72,82.52 421.90,84.99 419.95,86.02
      419.03,86.53 417.90,86.94 416.77,87.47
      414.10,88.39 410.91,88.80 407.42,88.80 Z
      M 397.66,61.81
      C 397.66,61.81 413.58,61.81 413.58,61.81
      414.20,61.81 414.61,61.29 414.61,60.77
      414.61,60.77 414.61,60.77 414.61,60.77
      414.61,58.92 414.30,57.16 413.68,55.73
      413.07,54.29 412.25,53.15 411.01,52.32
      409.78,51.50 408.24,51.09 406.29,51.09
      404.65,51.09 403.21,51.50 401.97,52.43
      400.74,53.35 399.71,54.60 399.00,56.14
      398.28,57.69 397.76,59.54 397.45,61.50
      397.45,61.50 397.66,61.81 397.66,61.81 Z" />
      <path id="netsnek-k" d="M 470.60,80.54
      C 470.60,80.54 458.19,64.57 458.19,64.57
      457.67,63.94 457.77,63.01 458.39,62.49
      458.39,62.49 468.32,53.15 468.32,53.15
      468.74,52.74 469.25,52.43 469.87,52.33
      469.87,52.33 472.15,51.81 472.15,51.81
      473.70,51.50 474.73,50.14 474.73,48.59
      474.73,48.59 474.73,48.28 474.73,48.28
      474.73,46.41 473.29,44.96 471.42,44.96
      471.42,44.96 456.74,44.96 456.74,44.96
      454.88,44.96 453.43,46.41 453.43,48.28
      453.43,48.28 453.43,48.39 453.43,48.39
      453.43,50.04 454.67,51.40 456.33,51.71
      456.33,51.71 458.08,51.91 458.08,51.91
      458.08,51.91 457.98,52.12 457.98,52.12
      457.98,52.12 447.02,62.49 447.02,62.49
      445.98,63.42 444.43,62.70 444.43,61.35
      444.43,61.35 444.43,32.31 444.43,32.31
      444.43,30.43 442.99,28.99 441.12,28.99
      441.12,28.99 430.99,28.99 430.99,28.99
      429.13,28.99 427.68,30.43 427.68,32.31
      427.68,32.31 427.68,32.62 427.68,32.62
      427.68,34.17 428.82,35.52 430.37,35.83
      430.37,35.83 431.51,36.04 431.51,36.04
      433.06,36.35 434.20,37.70 434.20,39.25
      434.20,39.25 434.20,78.88 434.20,78.88
      434.20,80.43 433.06,81.79 431.51,82.10
      431.51,82.10 430.68,82.31 430.68,82.31
      429.13,82.62 427.99,83.97 427.99,85.52
      427.99,85.52 427.99,85.63 427.99,85.63
      427.99,87.50 429.44,88.94 431.30,88.94
      431.30,88.94 446.81,88.94 446.81,88.94
      448.67,88.94 450.12,87.50 450.12,85.63
      450.12,85.63 450.12,85.32 450.12,85.32
      450.12,83.75 448.98,82.41 447.54,82.10
      447.54,82.10 447.02,82.00 447.02,82.00
      445.47,81.69 444.43,80.33 444.43,78.78
      444.43,78.78 444.43,77.11 444.43,77.11
      444.43,76.18 444.85,75.36 445.47,74.74
      445.47,74.74 449.40,71.00 449.40,71.00
      450.02,70.37 451.16,70.48 451.67,71.21
      451.67,71.21 459.84,82.00 459.84,82.00
      459.84,82.00 459.95,82.20 459.95,82.20
      459.95,82.20 458.81,82.41 458.81,82.41
      457.26,82.72 456.12,84.07 456.12,85.63
      456.12,85.63 456.12,85.63 456.12,85.63
      456.12,87.50 457.57,88.94 459.43,88.94
      459.43,88.94 474.01,88.94 474.01,88.94
      475.87,88.94 477.32,87.50 477.32,85.63
      477.32,85.63 477.32,85.42 477.32,85.42
      477.32,83.86 476.18,82.51 474.63,82.20
      474.63,82.20 472.67,81.79 472.67,81.79
      471.73,81.69 471.11,81.27 470.60,80.54 Z" />
      </g>
      <g id="tagline" fill="currentColor">
      <path id="tagline-s-1" d="M 174.03,110.49
      C 172.72,110.49 171.65,110.30 170.79,109.94
      169.94,109.57 169.29,109.08 168.84,108.49
      168.40,107.89 168.17,107.26 168.14,106.58
      168.14,106.48 168.18,106.39 168.26,106.30
      168.35,106.21 168.45,106.16 168.58,106.16
      168.58,106.16 171.03,106.16 171.03,106.16
      171.20,106.16 171.34,106.20 171.44,106.27
      171.54,106.33 171.63,106.42 171.72,106.52
      171.82,106.72 171.97,106.91 172.15,107.10
      172.34,107.28 172.59,107.42 172.90,107.53
      173.22,107.64 173.59,107.69 174.03,107.69
      174.78,107.69 175.35,107.58 175.73,107.35
      176.11,107.11 176.31,106.78 176.31,106.38
      176.31,106.08 176.20,105.84 176.00,105.66
      175.79,105.48 175.45,105.32 175.00,105.18
      174.54,105.02 173.92,104.86 173.15,104.71
      172.16,104.50 171.32,104.23 170.62,103.89
      169.94,103.56 169.41,103.13 169.04,102.60
      168.68,102.06 168.50,101.38 168.50,100.57
      168.50,99.78 168.72,99.07 169.17,98.44
      169.61,97.82 170.24,97.33 171.04,96.99
      171.86,96.64 172.81,96.46 173.92,96.46
      174.81,96.46 175.60,96.58 176.28,96.82
      176.97,97.05 177.54,97.36 178.01,97.75
      178.48,98.14 178.83,98.55 179.08,98.99
      179.31,99.42 179.44,99.84 179.45,100.25
      179.45,100.36 179.41,100.45 179.34,100.53
      179.27,100.62 179.17,100.66 179.04,100.66
      179.04,100.66 176.47,100.66 176.47,100.66
      176.32,100.66 176.19,100.64 176.09,100.60
      175.99,100.55 175.90,100.46 175.83,100.33
      175.74,100.05 175.53,99.81 175.20,99.60
      174.88,99.38 174.45,99.27 173.92,99.27
      173.35,99.27 172.90,99.37 172.58,99.57
      172.26,99.76 172.11,100.07 172.11,100.49
      172.11,100.75 172.19,100.98 172.36,101.18
      172.53,101.37 172.83,101.55 173.23,101.69
      173.65,101.83 174.21,101.97 174.92,102.13
      176.11,102.35 177.06,102.62 177.79,102.96
      178.52,103.29 179.06,103.72 179.40,104.25
      179.75,104.78 179.92,105.43 179.92,106.22
      179.92,107.11 179.66,107.87 179.15,108.50
      178.65,109.14 177.96,109.63 177.08,109.97
      176.20,110.32 175.19,110.49 174.03,110.49 Z" />
      <path id="tagline-o-1" d="M 187.65,110.54
      C 186.56,110.54 185.64,110.37 184.89,110.02
      184.14,109.67 183.56,109.16 183.17,108.51
      182.77,107.85 182.55,107.07 182.50,106.16
      182.49,105.90 182.48,105.61 182.48,105.27
      182.48,104.94 182.49,104.65 182.50,104.40
      182.55,103.48 182.78,102.70 183.20,102.05
      183.61,101.40 184.20,100.90 184.95,100.55
      185.70,100.20 186.60,100.02 187.65,100.02
      188.72,100.02 189.61,100.20 190.36,100.55
      191.11,100.90 191.69,101.40 192.11,102.05
      192.52,102.70 192.76,103.48 192.81,104.40
      192.83,104.65 192.84,104.94 192.84,105.27
      192.84,105.61 192.83,105.90 192.81,106.16
      192.76,107.07 192.53,107.85 192.14,108.51
      191.74,109.16 191.17,109.67 190.42,110.02
      189.68,110.37 188.76,110.54 187.65,110.54 Z
      M 187.65,108.16
      C 188.24,108.16 188.66,107.99 188.92,107.65
      189.19,107.30 189.35,106.76 189.39,106.05
      189.40,105.87 189.40,105.61 189.40,105.29
      189.40,104.96 189.40,104.69 189.39,104.51
      189.35,103.81 189.19,103.28 188.92,102.93
      188.66,102.58 188.24,102.40 187.65,102.40
      187.09,102.40 186.67,102.58 186.39,102.93
      186.11,103.28 185.95,103.81 185.94,104.51
      185.92,104.69 185.92,104.96 185.92,105.29
      185.92,105.61 185.92,105.87 185.94,106.05
      185.95,106.76 186.11,107.30 186.39,107.65
      186.67,107.99 187.09,108.16 187.65,108.16 Z" />
      <path id="tagline-f-1" d="M 197.58,110.32
      C 197.46,110.32 197.34,110.28 197.24,110.18
      197.14,110.08 197.10,109.97 197.10,109.84
      197.10,109.84 197.10,102.75 197.10,102.75
      197.10,102.75 195.61,102.75 195.61,102.75
      195.48,102.75 195.36,102.70 195.27,102.61
      195.18,102.51 195.13,102.40 195.13,102.25
      195.13,102.25 195.13,100.67 195.13,100.67
      195.13,100.54 195.18,100.42 195.27,100.32
      195.36,100.23 195.48,100.18 195.61,100.18
      195.61,100.18 197.10,100.18 197.10,100.18
      197.10,100.18 197.10,99.56 197.10,99.56
      197.10,98.68 197.27,97.97 197.61,97.43
      197.96,96.90 198.45,96.50 199.08,96.26
      199.73,96.01 200.49,95.89 201.38,95.89
      201.38,95.89 202.89,95.89 202.89,95.89
      203.04,95.89 203.15,95.93 203.24,96.03
      203.33,96.12 203.38,96.24 203.38,96.39
      203.38,96.39 203.38,97.97 203.38,97.97
      203.38,98.10 203.33,98.22 203.24,98.31
      203.15,98.40 203.04,98.45 202.89,98.45
      202.89,98.45 201.54,98.45 201.54,98.45
      201.09,98.45 200.77,98.56 200.60,98.76
      200.42,98.97 200.33,99.27 200.33,99.65
      200.33,99.65 200.33,100.18 200.33,100.18
      200.33,100.18 202.69,100.18 202.69,100.18
      202.84,100.18 202.96,100.23 203.05,100.32
      203.14,100.42 203.19,100.54 203.19,100.67
      203.19,100.67 203.19,102.25 203.19,102.25
      203.19,102.40 203.14,102.51 203.05,102.61
      202.96,102.70 202.84,102.75 202.69,102.75
      202.69,102.75 200.33,102.75 200.33,102.75
      200.33,102.75 200.33,109.84 200.33,109.84
      200.33,109.97 200.29,110.08 200.19,110.18
      200.11,110.28 199.99,110.32 199.85,110.32
      199.85,110.32 197.58,110.32 197.58,110.32 Z" />
      <path id="tagline-t-2" d="M 211.27,110.35
      C 210.43,110.35 209.71,110.22 209.11,109.96
      208.51,109.69 208.04,109.27 207.71,108.71
      207.38,108.14 207.22,107.40 207.22,106.51
      207.22,106.51 207.22,102.77 207.22,102.77
      207.22,102.77 205.71,102.77 205.71,102.77
      205.56,102.77 205.43,102.72 205.33,102.63
      205.24,102.54 205.19,102.42 205.19,102.27
      205.19,102.27 205.19,100.69 205.19,100.69
      205.19,100.56 205.24,100.44 205.33,100.35
      205.43,100.26 205.56,100.21 205.71,100.21
      205.71,100.21 207.22,100.21 207.22,100.21
      207.22,100.21 207.22,96.99 207.22,96.99
      207.22,96.85 207.27,96.73 207.36,96.65
      207.46,96.55 207.58,96.51 207.71,96.51
      207.71,96.51 209.97,96.51 209.97,96.51
      210.12,96.51 210.23,96.55 210.32,96.65
      210.41,96.73 210.46,96.85 210.46,96.99
      210.46,96.99 210.46,100.21 210.46,100.21
      210.46,100.21 212.89,100.21 212.89,100.21
      213.04,100.21 213.16,100.26 213.25,100.35
      213.36,100.44 213.41,100.56 213.41,100.69
      213.41,100.69 213.41,102.27 213.41,102.27
      213.41,102.42 213.36,102.54 213.25,102.63
      213.16,102.72 213.04,102.77 212.89,102.77
      212.89,102.77 210.46,102.77 210.46,102.77
      210.46,102.77 210.46,106.24 210.46,106.24
      210.46,106.68 210.54,107.03 210.71,107.29
      210.88,107.55 211.18,107.68 211.58,107.68
      211.58,107.68 213.08,107.68 213.08,107.68
      213.21,107.68 213.33,107.72 213.43,107.82
      213.52,107.90 213.57,108.02 213.57,108.16
      213.57,108.16 213.57,109.87 213.57,109.87
      213.57,109.99 213.52,110.11 213.43,110.21
      213.33,110.30 213.21,110.35 213.08,110.35
      213.08,110.35 211.27,110.35 211.27,110.35 Z" />
      <path id="tagline-w" d="M 218.96,110.35
      C 218.76,110.35 218.62,110.30 218.52,110.21
      218.43,110.11 218.35,109.99 218.30,109.87
      218.30,109.87 215.51,100.83 215.51,100.83
      215.48,100.77 215.46,100.71 215.46,100.63
      215.46,100.52 215.51,100.42 215.60,100.33
      215.69,100.25 215.80,100.21 215.91,100.21
      215.91,100.21 217.91,100.21 217.91,100.21
      218.09,100.21 218.23,100.26 218.32,100.35
      218.41,100.44 218.48,100.53 218.51,100.62
      218.51,100.62 220.15,106.19 220.15,106.19
      220.15,106.19 221.90,100.63 221.90,100.63
      221.93,100.55 221.99,100.46 222.09,100.37
      222.18,100.26 222.32,100.21 222.51,100.21
      222.51,100.21 223.79,100.21 223.79,100.21
      223.98,100.21 224.12,100.26 224.23,100.37
      224.33,100.46 224.39,100.55 224.40,100.63
      224.40,100.63 226.15,106.19 226.15,106.19
      226.15,106.19 227.79,100.62 227.79,100.62
      227.81,100.53 227.87,100.44 227.96,100.35
      228.06,100.26 228.20,100.21 228.37,100.21
      228.37,100.21 230.38,100.21 230.38,100.21
      230.50,100.21 230.60,100.25 230.69,100.33
      230.79,100.42 230.84,100.52 230.84,100.63
      230.84,100.71 230.82,100.77 230.79,100.83
      230.79,100.83 227.98,109.87 227.98,109.87
      227.94,109.99 227.87,110.11 227.77,110.21
      227.68,110.30 227.53,110.35 227.34,110.35
      227.34,110.35 225.59,110.35 225.59,110.35
      225.40,110.35 225.25,110.30 225.15,110.21
      225.04,110.11 224.98,109.99 224.94,109.87
      224.94,109.87 223.15,104.52 223.15,104.52
      223.15,104.52 221.35,109.87 221.35,109.87
      221.31,109.99 221.23,110.11 221.13,110.21
      221.03,110.30 220.89,110.35 220.71,110.35
      220.71,110.35 218.96,110.35 218.96,110.35 Z" />
      <path id="tagline-a" d="M 236.29,110.51
      C 235.59,110.51 234.96,110.38 234.41,110.12
      233.86,109.85 233.42,109.49 233.09,109.04
      232.76,108.59 232.60,108.07 232.60,107.50
      232.60,106.57 232.98,105.84 233.73,105.31
      234.48,104.77 235.49,104.40 236.74,104.20
      236.74,104.20 239.18,103.82 239.18,103.82
      239.18,103.82 239.18,103.56 239.18,103.56
      239.18,103.09 239.08,102.74 238.88,102.50
      238.69,102.25 238.34,102.12 237.82,102.12
      237.45,102.12 237.16,102.20 236.93,102.34
      236.70,102.48 236.52,102.67 236.40,102.92
      236.27,103.09 236.10,103.17 235.90,103.17
      235.90,103.17 233.73,103.17 233.73,103.17
      233.58,103.17 233.46,103.13 233.38,103.04
      233.31,102.96 233.28,102.86 233.29,102.75
      233.29,102.51 233.37,102.24 233.55,101.93
      233.73,101.62 234.00,101.32 234.37,101.03
      234.73,100.73 235.20,100.48 235.77,100.29
      236.34,100.10 237.04,100.00 237.85,100.00
      238.68,100.00 239.40,100.10 239.99,100.29
      240.59,100.48 241.09,100.75 241.46,101.11
      241.84,101.45 242.11,101.86 242.29,102.34
      242.46,102.81 242.55,103.33 242.55,103.90
      242.55,103.90 242.55,109.84 242.55,109.84
      242.55,109.97 242.50,110.08 242.40,110.18
      242.30,110.28 242.19,110.32 242.07,110.32
      242.07,110.32 239.80,110.32 239.80,110.32
      239.66,110.32 239.54,110.28 239.44,110.18
      239.36,110.08 239.32,109.97 239.32,109.84
      239.32,109.84 239.32,109.15 239.32,109.15
      239.15,109.40 238.92,109.63 238.63,109.84
      238.35,110.05 238.01,110.21 237.63,110.32
      237.25,110.45 236.80,110.51 236.29,110.51 Z
      M 237.21,108.29
      C 237.59,108.29 237.92,108.22 238.23,108.06
      238.54,107.90 238.78,107.64 238.96,107.29
      239.14,106.95 239.23,106.52 239.23,106.00
      239.23,106.00 239.23,105.72 239.23,105.72
      239.23,105.72 237.55,106.01 237.55,106.01
      236.95,106.12 236.51,106.28 236.23,106.50
      235.94,106.71 235.80,106.96 235.80,107.25
      235.80,107.47 235.87,107.65 235.99,107.81
      236.12,107.97 236.30,108.09 236.51,108.17
      236.73,108.25 236.96,108.29 237.21,108.29 Z" />
      <path id="tagline-r-1" d="M 246.84,110.32
      C 246.69,110.32 246.58,110.28 246.48,110.18
      246.40,110.08 246.36,109.97 246.36,109.84
      246.36,109.84 246.36,100.67 246.36,100.67
      246.36,100.54 246.40,100.43 246.48,100.34
      246.58,100.24 246.69,100.18 246.84,100.18
      246.84,100.18 249.08,100.18 249.08,100.18
      249.22,100.18 249.34,100.24 249.44,100.34
      249.54,100.43 249.59,100.54 249.59,100.67
      249.59,100.67 249.59,101.45 249.59,101.45
      249.92,101.04 250.33,100.73 250.83,100.51
      251.31,100.29 251.86,100.18 252.48,100.18
      252.48,100.18 253.33,100.18 253.33,100.18
      253.47,100.18 253.59,100.23 253.69,100.32
      253.78,100.42 253.83,100.54 253.83,100.67
      253.83,100.67 253.83,102.68 253.83,102.68
      253.83,102.81 253.78,102.93 253.69,103.03
      253.59,103.12 253.47,103.17 253.33,103.17
      253.33,103.17 251.44,103.17 251.44,103.17
      250.90,103.17 250.49,103.32 250.20,103.61
      249.91,103.90 249.76,104.31 249.76,104.84
      249.76,104.84 249.76,109.84 249.76,109.84
      249.76,109.97 249.71,110.08 249.61,110.18
      249.51,110.28 249.40,110.32 249.26,110.32
      249.26,110.32 246.84,110.32 246.84,110.32 Z" />
      <path id="tagline-e-1" d="M 261.13,110.51
      C 259.60,110.51 258.37,110.10 257.46,109.28
      256.55,108.45 256.07,107.21 256.04,105.56
      256.04,105.48 256.04,105.36 256.04,105.22
      256.04,105.07 256.04,104.96 256.04,104.89
      256.07,103.86 256.30,102.98 256.72,102.25
      257.15,101.51 257.74,100.95 258.49,100.57
      259.24,100.19 260.11,100.00 261.11,100.00
      262.26,100.00 263.20,100.23 263.94,100.68
      264.69,101.13 265.25,101.75 265.63,102.53
      266.01,103.31 266.21,104.20 266.21,105.20
      266.21,105.20 266.21,105.67 266.21,105.67
      266.21,105.81 266.16,105.92 266.07,106.01
      265.97,106.11 265.85,106.15 265.71,106.15
      265.71,106.15 259.47,106.15 259.47,106.15
      259.47,106.16 259.47,106.18 259.47,106.22
      259.47,106.24 259.47,106.26 259.47,106.29
      259.48,106.67 259.55,107.01 259.68,107.32
      259.80,107.64 259.98,107.89 260.22,108.07
      260.46,108.25 260.76,108.34 261.11,108.34
      261.37,108.34 261.59,108.30 261.77,108.22
      261.95,108.12 262.09,108.02 262.21,107.92
      262.32,107.81 262.41,107.71 262.47,107.64
      262.59,107.49 262.68,107.40 262.75,107.37
      262.82,107.34 262.94,107.32 263.10,107.32
      263.10,107.32 265.52,107.32 265.52,107.32
      265.64,107.32 265.75,107.37 265.83,107.45
      265.93,107.52 265.96,107.62 265.94,107.75
      265.93,107.97 265.82,108.23 265.61,108.54
      265.40,108.86 265.10,109.17 264.71,109.48
      264.31,109.79 263.81,110.04 263.21,110.23
      262.61,110.42 261.92,110.51 261.13,110.51 Z
      M 259.47,104.22
      C 259.47,104.22 262.77,104.22 262.77,104.22
      262.77,104.22 262.77,104.18 262.77,104.18
      262.77,103.76 262.71,103.40 262.58,103.09
      262.46,102.78 262.27,102.54 262.02,102.37
      261.77,102.21 261.46,102.12 261.11,102.12
      260.77,102.12 260.47,102.21 260.22,102.37
      259.98,102.54 259.79,102.78 259.66,103.09
      259.54,103.40 259.47,103.76 259.47,104.18
      259.47,104.18 259.47,104.22 259.47,104.22 Z" />
      <path id="tagline-amp" d="M 279.33,110.53
      C 278.32,110.53 277.44,110.37 276.69,110.06
      275.95,109.74 275.37,109.28 274.96,108.68
      274.55,108.09 274.35,107.38 274.35,106.54
      274.35,105.98 274.46,105.48 274.68,105.04
      274.89,104.60 275.20,104.19 275.60,103.82
      275.99,103.46 276.45,103.13 276.97,102.84
      276.48,102.29 276.13,101.78 275.91,101.32
      275.70,100.85 275.60,100.39 275.60,99.93
      275.60,99.32 275.75,98.76 276.07,98.24
      276.38,97.72 276.85,97.30 277.49,96.98
      278.12,96.66 278.90,96.49 279.83,96.49
      280.70,96.49 281.43,96.65 282.02,96.96
      282.62,97.28 283.08,97.69 283.39,98.20
      283.71,98.71 283.88,99.27 283.88,99.87
      283.88,100.39 283.76,100.86 283.54,101.28
      283.32,101.69 283.00,102.07 282.60,102.42
      282.19,102.76 281.71,103.09 281.18,103.40
      281.18,103.40 283.49,105.71 283.49,105.71
      283.58,105.55 283.73,105.28 283.93,104.92
      284.13,104.55 284.32,104.07 284.49,103.48
      284.53,103.29 284.66,103.20 284.89,103.20
      284.89,103.20 286.86,103.20 286.86,103.20
      286.98,103.20 287.07,103.24 287.14,103.31
      287.21,103.38 287.25,103.47 287.25,103.57
      287.24,103.82 287.18,104.11 287.05,104.45
      286.93,104.77 286.78,105.12 286.58,105.49
      286.39,105.86 286.18,106.21 285.94,106.56
      285.71,106.89 285.49,107.20 285.27,107.49
      285.27,107.49 287.46,109.70 287.46,109.70
      287.54,109.80 287.58,109.90 287.58,109.99
      287.58,110.10 287.55,110.18 287.49,110.24
      287.43,110.31 287.34,110.34 287.22,110.34
      287.22,110.34 284.57,110.34 284.57,110.34
      284.43,110.34 284.32,110.32 284.24,110.28
      284.16,110.22 284.10,110.18 284.05,110.15
      284.05,110.15 283.18,109.31 283.18,109.31
      282.64,109.74 282.06,110.05 281.43,110.24
      280.80,110.43 280.10,110.53 279.33,110.53 Z
      M 279.33,108.06
      C 279.71,108.06 280.08,108.00 280.43,107.88
      280.77,107.77 281.07,107.59 281.35,107.34
      281.35,107.34 278.75,104.74 278.75,104.74
      278.40,104.92 278.10,105.15 277.85,105.43
      277.60,105.71 277.47,106.04 277.47,106.40
      277.47,106.76 277.56,107.06 277.74,107.31
      277.93,107.55 278.16,107.74 278.44,107.87
      278.72,107.99 279.02,108.06 279.33,108.06 Z
      M 279.52,101.60
      C 279.81,101.45 280.07,101.29 280.30,101.13
      280.54,100.98 280.73,100.81 280.88,100.62
      281.02,100.42 281.10,100.20 281.10,99.96
      281.10,99.61 280.98,99.33 280.74,99.12
      280.50,98.90 280.20,98.79 279.83,98.79
      279.50,98.79 279.20,98.90 278.94,99.10
      278.68,99.31 278.55,99.60 278.55,99.98
      278.55,100.13 278.58,100.29 278.64,100.45
      278.71,100.60 278.80,100.78 278.94,100.96
      279.09,101.15 279.28,101.36 279.52,101.60 Z" />
      <path id="tagline-s-2" d="M 300.14,110.51
      C 298.84,110.51 297.76,110.33 296.91,109.97
      296.05,109.59 295.40,109.11 294.95,108.51
      294.52,107.92 294.28,107.29 294.25,106.61
      294.25,106.50 294.29,106.41 294.38,106.32
      294.46,106.23 294.56,106.18 294.69,106.18
      294.69,106.18 297.14,106.18 297.14,106.18
      297.32,106.18 297.45,106.22 297.55,106.29
      297.65,106.36 297.74,106.44 297.83,106.54
      297.93,106.74 298.08,106.93 298.27,107.12
      298.45,107.30 298.70,107.45 299.02,107.56
      299.33,107.66 299.70,107.72 300.14,107.72
      300.89,107.72 301.46,107.60 301.84,107.37
      302.23,107.13 302.42,106.81 302.42,106.40
      302.42,106.10 302.32,105.86 302.11,105.68
      301.90,105.51 301.57,105.35 301.11,105.20
      300.65,105.04 300.04,104.89 299.27,104.73
      298.27,104.52 297.43,104.25 296.74,103.92
      296.05,103.59 295.52,103.15 295.16,102.62
      294.79,102.08 294.61,101.40 294.61,100.59
      294.61,99.80 294.83,99.09 295.28,98.47
      295.73,97.84 296.35,97.36 297.16,97.01
      297.97,96.66 298.93,96.48 300.03,96.48
      300.93,96.48 301.71,96.60 302.39,96.84
      303.08,97.07 303.66,97.38 304.13,97.78
      304.59,98.16 304.95,98.57 305.19,99.01
      305.43,99.44 305.55,99.86 305.56,100.28
      305.56,100.38 305.52,100.48 305.45,100.56
      305.38,100.65 305.28,100.68 305.16,100.68
      305.16,100.68 302.58,100.68 302.58,100.68
      302.43,100.68 302.31,100.66 302.20,100.62
      302.10,100.57 302.01,100.48 301.94,100.36
      301.85,100.07 301.65,99.83 301.31,99.62
      300.99,99.40 300.56,99.29 300.03,99.29
      299.46,99.29 299.01,99.40 298.69,99.59
      298.38,99.79 298.22,100.10 298.22,100.51
      298.22,100.77 298.30,101.00 298.47,101.20
      298.65,101.40 298.94,101.57 299.34,101.72
      299.76,101.85 300.32,102.00 301.03,102.15
      302.22,102.37 303.18,102.65 303.91,102.98
      304.63,103.32 305.17,103.75 305.52,104.28
      305.86,104.80 306.03,105.46 306.03,106.25
      306.03,107.13 305.77,107.90 305.27,108.53
      304.77,109.16 304.07,109.65 303.19,110.00
      302.31,110.34 301.30,110.51 300.14,110.51 Z" />
      <path id="tagline-e-2" d="M 313.62,110.54
      C 312.09,110.54 310.86,110.13 309.94,109.30
      309.04,108.47 308.56,107.23 308.52,105.58
      308.52,105.50 308.52,105.39 308.52,105.24
      308.52,105.10 308.52,104.99 308.52,104.91
      308.56,103.88 308.79,103.00 309.21,102.27
      309.64,101.53 310.23,100.97 310.98,100.60
      311.73,100.22 312.60,100.02 313.60,100.02
      314.75,100.02 315.69,100.25 316.43,100.71
      317.18,101.16 317.74,101.77 318.12,102.55
      318.50,103.33 318.69,104.22 318.69,105.22
      318.69,105.22 318.69,105.69 318.69,105.69
      318.69,105.83 318.65,105.94 318.55,106.04
      318.46,106.13 318.34,106.18 318.19,106.18
      318.19,106.18 311.96,106.18 311.96,106.18
      311.96,106.19 311.96,106.21 311.96,106.24
      311.96,106.26 311.96,106.29 311.96,106.32
      311.97,106.69 312.04,107.04 312.16,107.35
      312.29,107.66 312.47,107.91 312.71,108.10
      312.95,108.28 313.25,108.37 313.60,108.37
      313.86,108.37 314.08,108.33 314.26,108.24
      314.43,108.15 314.58,108.05 314.69,107.94
      314.81,107.83 314.90,107.74 314.96,107.66
      315.07,107.52 315.17,107.43 315.24,107.40
      315.31,107.37 315.43,107.35 315.59,107.35
      315.59,107.35 318.01,107.35 318.01,107.35
      318.13,107.35 318.23,107.39 318.32,107.47
      318.41,107.55 318.45,107.65 318.43,107.77
      318.42,107.99 318.31,108.26 318.10,108.57
      317.89,108.88 317.59,109.19 317.19,109.51
      316.80,109.81 316.30,110.06 315.69,110.26
      315.10,110.44 314.41,110.54 313.62,110.54 Z
      M 311.96,104.24
      C 311.96,104.24 315.26,104.24 315.26,104.24
      315.26,104.24 315.26,104.21 315.26,104.21
      315.26,103.78 315.19,103.42 315.07,103.12
      314.94,102.80 314.76,102.56 314.51,102.40
      314.26,102.23 313.95,102.15 313.60,102.15
      313.26,102.15 312.96,102.23 312.71,102.40
      312.47,102.56 312.28,102.80 312.15,103.12
      312.02,103.42 311.96,103.78 311.96,104.21
      311.96,104.21 311.96,104.24 311.96,104.24 Z" />
      <path id="tagline-c" d="M 326.70,110.54
      C 325.74,110.54 324.89,110.37 324.14,110.02
      323.40,109.67 322.81,109.16 322.37,108.49
      321.94,107.83 321.71,107.02 321.67,106.08
      321.66,105.88 321.65,105.62 321.65,105.30
      321.65,104.98 321.66,104.72 321.67,104.51
      321.71,103.55 321.94,102.74 322.37,102.07
      322.80,101.40 323.39,100.90 324.14,100.55
      324.89,100.20 325.74,100.02 326.70,100.02
      327.60,100.02 328.36,100.15 329.01,100.40
      329.66,100.65 330.18,100.97 330.58,101.35
      330.97,101.72 331.27,102.11 331.47,102.51
      331.66,102.90 331.77,103.25 331.79,103.54
      331.80,103.67 331.76,103.80 331.65,103.90
      331.55,103.99 331.43,104.04 331.29,104.04
      331.29,104.04 328.83,104.04 328.83,104.04
      328.68,104.04 328.56,104.01 328.48,103.94
      328.41,103.87 328.34,103.77 328.28,103.65
      328.12,103.24 327.92,102.96 327.69,102.79
      327.44,102.62 327.14,102.54 326.76,102.54
      326.24,102.54 325.84,102.71 325.56,103.04
      325.28,103.37 325.13,103.89 325.11,104.60
      325.08,105.12 325.08,105.58 325.11,105.97
      325.14,106.69 325.29,107.22 325.56,107.54
      325.84,107.86 326.24,108.02 326.76,108.02
      327.16,108.02 327.47,107.94 327.70,107.77
      327.94,107.60 328.13,107.31 328.28,106.91
      328.34,106.79 328.41,106.69 328.48,106.63
      328.56,106.56 328.68,106.52 328.83,106.52
      328.83,106.52 331.29,106.52 331.29,106.52
      331.43,106.52 331.55,106.57 331.65,106.66
      331.76,106.76 331.80,106.88 331.79,107.02
      331.77,107.23 331.70,107.49 331.59,107.79
      331.47,108.08 331.29,108.39 331.04,108.71
      330.79,109.03 330.47,109.33 330.08,109.62
      329.68,109.89 329.20,110.11 328.64,110.29
      328.08,110.45 327.44,110.54 326.70,110.54 Z" />
      <path id="tagline-u" d="M 338.86,110.54
      C 338.12,110.54 337.46,110.37 336.88,110.04
      336.30,109.71 335.85,109.21 335.52,108.55
      335.20,107.90 335.04,107.09 335.04,106.13
      335.04,106.13 335.04,100.69 335.04,100.69
      335.04,100.56 335.08,100.44 335.18,100.35
      335.27,100.26 335.39,100.21 335.54,100.21
      335.54,100.21 337.97,100.21 337.97,100.21
      338.11,100.21 338.22,100.26 338.32,100.35
      338.42,100.44 338.47,100.56 338.47,100.69
      338.47,100.69 338.47,106.02 338.47,106.02
      338.47,107.30 339.04,107.93 340.18,107.93
      340.71,107.93 341.13,107.77 341.44,107.44
      341.76,107.11 341.93,106.64 341.93,106.02
      341.93,106.02 341.93,100.69 341.93,100.69
      341.93,100.56 341.96,100.44 342.05,100.35
      342.14,100.26 342.26,100.21 342.41,100.21
      342.41,100.21 344.85,100.21 344.85,100.21
      344.99,100.21 345.11,100.26 345.19,100.35
      345.29,100.44 345.33,100.56 345.33,100.69
      345.33,100.69 345.33,109.87 345.33,109.87
      345.33,109.99 345.29,110.11 345.19,110.21
      345.11,110.30 344.99,110.35 344.85,110.35
      344.85,110.35 342.58,110.35 342.58,110.35
      342.46,110.35 342.34,110.30 342.24,110.21
      342.14,110.11 342.10,109.99 342.10,109.87
      342.10,109.87 342.10,109.12 342.10,109.12
      341.76,109.58 341.32,109.94 340.79,110.18
      340.24,110.42 339.60,110.54 338.86,110.54 Z" />
      <path id="tagline-r-2" d="M 348.73,110.34
      C 348.58,110.34 348.46,110.29 348.37,110.20
      348.28,110.10 348.24,109.98 348.24,109.85
      348.24,109.85 348.24,100.68 348.24,100.68
      348.24,100.56 348.28,100.45 348.37,100.35
      348.46,100.25 348.58,100.20 348.73,100.20
      348.73,100.20 350.96,100.20 350.96,100.20
      351.11,100.20 351.23,100.25 351.32,100.35
      351.42,100.45 351.48,100.56 351.48,100.68
      351.48,100.68 351.48,101.46 351.48,101.46
      351.81,101.06 352.22,100.74 352.71,100.53
      353.20,100.31 353.75,100.20 354.37,100.20
      354.37,100.20 355.21,100.20 355.21,100.20
      355.36,100.20 355.48,100.24 355.57,100.34
      355.67,100.43 355.71,100.55 355.71,100.68
      355.71,100.68 355.71,102.70 355.71,102.70
      355.71,102.82 355.67,102.94 355.57,103.04
      355.48,103.13 355.36,103.18 355.21,103.18
      355.21,103.18 353.32,103.18 353.32,103.18
      352.79,103.18 352.38,103.33 352.09,103.62
      351.80,103.91 351.65,104.32 351.65,104.85
      351.65,104.85 351.65,109.85 351.65,109.85
      351.65,109.98 351.60,110.10 351.49,110.20
      351.40,110.29 351.28,110.34 351.15,110.34
      351.15,110.34 348.73,110.34 348.73,110.34 Z" />
      <path id="tagline-i" d="M 358.83,110.35
      C 358.68,110.35 358.56,110.30 358.47,110.21
      358.38,110.11 358.34,109.99 358.34,109.87
      358.34,109.87 358.34,100.69 358.34,100.69
      358.34,100.56 358.38,100.44 358.47,100.35
      358.56,100.26 358.68,100.21 358.83,100.21
      358.83,100.21 361.13,100.21 361.13,100.21
      361.27,100.21 361.38,100.26 361.47,100.35
      361.56,100.44 361.61,100.56 361.61,100.69
      361.61,100.69 361.61,109.87 361.61,109.87
      361.61,109.99 361.56,110.11 361.47,110.21
      361.38,110.30 361.27,110.35 361.13,110.35
      361.13,110.35 358.83,110.35 358.83,110.35 Z
      M 358.81,98.74
      C 358.66,98.74 358.55,98.70 358.45,98.62
      358.36,98.52 358.31,98.40 358.31,98.26
      358.31,98.26 358.31,96.51 358.31,96.51
      358.31,96.37 358.36,96.26 358.45,96.16
      358.55,96.07 358.66,96.02 358.81,96.02
      358.81,96.02 361.14,96.02 361.14,96.02
      361.27,96.02 361.39,96.07 361.49,96.16
      361.59,96.26 361.64,96.37 361.64,96.51
      361.64,96.51 361.64,98.26 361.64,98.26
      361.64,98.40 361.59,98.52 361.49,98.62
      361.39,98.70 361.27,98.74 361.14,98.74
      361.14,98.74 358.81,98.74 358.81,98.74 Z" />
      <path id="tagline-t-1" d="M 370.62,110.35
      C 369.78,110.35 369.06,110.22 368.46,109.96
      367.86,109.69 367.39,109.27 367.06,108.71
      366.73,108.14 366.57,107.40 366.57,106.51
      366.57,106.51 366.57,102.77 366.57,102.77
      366.57,102.77 365.06,102.77 365.06,102.77
      364.91,102.77 364.78,102.72 364.68,102.63
      364.59,102.54 364.54,102.42 364.54,102.27
      364.54,102.27 364.54,100.69 364.54,100.69
      364.54,100.56 364.59,100.44 364.68,100.35
      364.78,100.26 364.91,100.21 365.06,100.21
      365.06,100.21 366.57,100.21 366.57,100.21
      366.57,100.21 366.57,96.99 366.57,96.99
      366.57,96.85 366.62,96.73 366.71,96.65
      366.81,96.55 366.93,96.51 367.06,96.51
      367.06,96.51 369.32,96.51 369.32,96.51
      369.47,96.51 369.58,96.55 369.67,96.65
      369.76,96.73 369.81,96.85 369.81,96.99
      369.81,96.99 369.81,100.21 369.81,100.21
      369.81,100.21 372.24,100.21 372.24,100.21
      372.39,100.21 372.51,100.26 372.60,100.35
      372.71,100.44 372.76,100.56 372.76,100.69
      372.76,100.69 372.76,102.27 372.76,102.27
      372.76,102.42 372.71,102.54 372.60,102.63
      372.51,102.72 372.39,102.77 372.24,102.77
      372.24,102.77 369.81,102.77 369.81,102.77
      369.81,102.77 369.81,106.24 369.81,106.24
      369.81,106.68 369.89,107.03 370.06,107.29
      370.23,107.55 370.53,107.68 370.93,107.68
      370.93,107.68 372.43,107.68 372.43,107.68
      372.56,107.68 372.68,107.72 372.78,107.82
      372.87,107.90 372.92,108.02 372.92,108.16
      372.92,108.16 372.92,109.87 372.92,109.87
      372.92,109.99 372.87,110.11 372.78,110.21
      372.68,110.30 372.56,110.35 372.43,110.35
      372.43,110.35 370.62,110.35 370.62,110.35 Z" />
      <path id="tagline-y" d="M 377.42,114.07
      C 377.30,114.07 377.19,114.02 377.11,113.94
      377.04,113.87 377.00,113.77 377.00,113.66
      377.00,113.63 377.00,113.59 377.02,113.55
      377.02,113.51 377.04,113.46 377.06,113.41
      377.06,113.41 378.59,109.74 378.59,109.74
      378.59,109.74 374.84,100.88 374.84,100.88
      374.80,100.80 374.78,100.72 374.78,100.64
      374.81,100.53 374.86,100.43 374.94,100.35
      375.02,100.26 375.12,100.22 375.24,100.22
      375.24,100.22 377.45,100.22 377.45,100.22
      377.62,100.22 377.74,100.26 377.83,100.35
      377.92,100.43 377.99,100.53 378.02,100.63
      378.02,100.63 380.25,106.30 380.25,106.30
      380.25,106.30 382.53,100.63 382.53,100.63
      382.58,100.53 382.65,100.43 382.74,100.35
      382.82,100.26 382.94,100.22 383.11,100.22
      383.11,100.22 385.30,100.22 385.30,100.22
      385.41,100.22 385.51,100.26 385.59,100.35
      385.68,100.43 385.72,100.53 385.72,100.63
      385.72,100.69 385.70,100.78 385.67,100.88
      385.67,100.88 380.14,113.66 380.14,113.66
      380.11,113.76 380.05,113.85 379.95,113.94
      379.86,114.02 379.73,114.07 379.56,114.07
      379.56,114.07 377.42,114.07 377.42,114.07 Z" />
      <path id="dot" fill="#f77f00" d="M 389.04,110.35
      C 388.89,110.35 388.77,110.30 388.68,110.21
      388.58,110.11 388.54,109.99 388.54,109.87
      388.54,109.87 388.54,107.38 388.54,107.38
      388.54,107.25 388.58,107.13 388.68,107.04
      388.77,106.94 388.89,106.90 389.04,106.90
      389.04,106.90 391.50,106.90 391.50,106.90
      391.64,106.90 391.75,106.94 391.85,107.04
      391.94,107.13 391.99,107.25 391.99,107.38
      391.99,107.38 391.99,109.87 391.99,109.87
      391.99,109.99 391.94,110.11 391.85,110.21
      391.75,110.30 391.64,110.35 391.50,110.35
      391.50,110.35 389.04,110.35 389.04,110.35 Z" />
      </g>
      </g>
    </chakra.svg>
  )
}

export default Logo
